import React, { useEffect } from "react";
import NoDataFound from "../Common/NoDataFound";
import Alert from "../Common/Alert";
import {
  convertFirstLetterOfFullNameToCapital,
  customName,
  getColorFromId,
} from "../../helpers/commonHelpers";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../Common/Loader";
import { getMomAcceptDetails } from "../../redux/actions/minuteActions/MinuteAction";

const MOMAcceptanceDetails = (props) => {
  const dispatch = useDispatch();
  const accessToken = localStorage.getItem("accessToken");
  const minuteData = useSelector((state) => state.minute);

  useEffect(() => {
    dispatch(getMomAcceptDetails(props?.meetingId, accessToken));
  }, []);

  return (
    <div className="form-group agenda">
      <label className="mt-2 mb-3 add-agenda">
        <h4 className="mb-0">MOM Acceptance Details</h4>
      </label>
      <div className="mt-2 agenda-box-border attendees-popup-list">
        {minuteData?.momAcceptDetails &&
          minuteData?.momAcceptDetails?.length !== 0 ? (
          <form className="details-form details-form-right responsive-table tbl-2-responsive ">
            <table className="table table-striped attendance-tbl">
              <thead>
                <tr className="text-align-center">
                  <th scope="col"  >Sl. No.</th>
                  <th scope="col" >Attendee(s)</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>

              <tbody>
                {minuteData?.momAcceptDetails?.length !== 0 ? (
                  <>
                    {minuteData?.momAcceptDetails?.map((attendee, index) => {
                      return (
                        <tr key={index}>
                          <td data-label="Sl. No." className="blue-bold-text">{index + 1}</td>
                          <td data-label="Attendees" className="acceptance-attendees">
                            <div className="attendees screen800-attendees">
                              {/* <div
                                className="attendee-list"
                                style={{
                                  backgroundColor: getColorFromId(
                                    attendee?.userDetails?._id
                                  ),
                                  borderRadius: "50px",
                                  padding: "4px 8px",
                                  color: "#fff",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  minWidth: "32px",
                                  height: "32px",
                                  
                                }}
                              >
                                {customName(attendee?.userDetails?.name)}
                              </div>  */}
                              <div
                                className="attendee-list attendee-list-circle"
                                style={{
                                  backgroundColor: attendee?.userDetails?.profilePicture
                                    ? undefined
                                    : getColorFromId(attendee?.userDetails?._id),
                                  // borderRadius: "50px",
                                  // padding: "4px 8px",
                                  // color: "#fff",
                                  // display: "flex",
                                  // alignItems: "center",
                                  // justifyContent: "center",
                                  // minWidth: "40px",
                                  // height: "40px",
                                  // overflow: "hidden",
                                }}
                              >
                                {attendee?.userDetails?.profilePicture ? (
                                  <img
                                    src={`${process.env.REACT_APP_API_URL}${attendee.userDetails.profilePicture}`}
                                    alt=""
                                    className="attendee-profile-picture icon-image profile-picture attendee-list-circle-img"
                                    style={{
                                      // width: "40px",
                                      // height: "40px",
                                      // borderRadius: "50%",
                                      // objectFit: "cover",
                                    }}
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.style.display = "none";
                                      // e.target.parentElement.style.backgroundColor = getColorFromId(attendee?.userDetails?._id);
                                      // e.target.parentElement.innerText = customName(attendee?.userDetails?.name);
                                      e.target.parentElement.style.backgroundColor = getColorFromId(
                                        attendee?.userDetails?._id
                                      );
                                      e.target.parentElement.innerText = customName(
                                        attendee?.userDetails?.name
                                      );
                                    }}
                                  />
                                ) : (
                                  customName(attendee?.userDetails?.name)
                                )}
                              </div>

                              <div className="action-cmnt-text">
                                <p className="detail-name word-break">
                                  {convertFirstLetterOfFullNameToCapital(
                                    attendee?.userDetails?.name
                                  )}
                                </p>

                                <p className="name-undertext detail-date-time global-email-width">
                                  {attendee?.userDetails?.email}
                                </p>
                              </div>
                            </div>
                          </td>
                          <td data-label="Status" className="acceptance-status">
                            {!attendee?.isAutoAccepted ? (
                              <p>
                                <span className="badge accepted-color">
                                  Accepted
                                </span>
                              </p>
                            ) : (
                              <p>
                                <span className="badge accepted-auto-color">
                                  {" "}
                                  Accepted (Auto)
                                </span>
                              </p>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </>
                ) : null}
              </tbody>
            </table>
          </form>
        ) : minuteData?.momAcceptDetails?.length === 0 &&
          !minuteData?.loading ? (
          <div className="no-data-img mt-3">
            <Alert
              status={"info"}
              message={"No data available."}
              timeoutSeconds={0}
            />
            <NoDataFound dataType={"meetingActivities"} />
          </div>
        ) : (
          <div
            className="meeting-page "
            style={{ textAlign: "center", paddingTop: 20 }}
          >
            <Loader />
          </div>
        )}
      </div>
    </div>
  );
};

export default MOMAcceptanceDetails;
